"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactChartjs = require("react-chartjs-2");

var _customHooks = _interopRequireDefault(require("../../../../customHooks"));

var _Box = _interopRequireDefault(require("../../../Box/Box"));

var _Flex = _interopRequireDefault(require("../../../Flex/Flex"));

var _config = _interopRequireDefault(require("./config"));

var _Legends = _interopRequireDefault(require("./02_Legends"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Graph = function Graph(_ref) {
  var dataset = _ref.dataset,
      colorScale = _ref.colorScale,
      _ref$disableAllAnimat = _ref.disableAllAnimation,
      disableAllAnimation = _ref$disableAllAnimat === void 0 ? false : _ref$disableAllAnimat;
  var chartRef = (0, _react.useRef)(null);

  var device = _customHooks["default"].useClientDevice();

  var _useState = (0, _react.useState)([]),
      legends = _useState[0],
      setLegends = _useState[1];

  var _useState2 = (0, _react.useState)(0),
      chartHeight = _useState2[0],
      setChartHeight = _useState2[1]; // The Pie chart ref get saved into state. Needs to be in useEffect with setLoaded
  // because for some reason on componentDidMount it does not get the ref. It gets the ref a tad later.
  // This is a documented bug and a solution similar to this is recommended


  var refForChart = chartRef == null ? void 0 : chartRef.current;
  (0, _react.useEffect)(function () {
    if (chartRef != null && chartRef.current) {
      var _chartRef$current, _chartRef$current$leg, _chartRef$current2, _chartRef$current2$ch;

      // Saves the legendItems that include legend colors, text etc.
      setLegends(chartRef == null ? void 0 : (_chartRef$current = chartRef.current) == null ? void 0 : (_chartRef$current$leg = _chartRef$current.legend) == null ? void 0 : _chartRef$current$leg.legendItems); // Saves the pie chart height which is used for determining the size of the box for labels.

      setChartHeight(chartRef == null ? void 0 : (_chartRef$current2 = chartRef.current) == null ? void 0 : (_chartRef$current2$ch = _chartRef$current2.chartArea) == null ? void 0 : _chartRef$current2$ch.height);
    }
  }, [refForChart]); // Add a default color scale incase color scale is not provided

  var data = (0, _extends2["default"])({}, dataset);
  data.datasets[0].backgroundColor = colorScale || _config["default"];
  var options = {
    maintainAspectRation: false,
    responsive: true,
    plugins: {
      legend: {
        display: false
      }
    },
    animation: disableAllAnimation ? false : {
      delay: 10
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    width: 1 / 1,
    flexDirection: ["column", "row", "row"],
    p: 3
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    width: ["100%", "50%", "50%"],
    pb: ["16px", "0px", "0px"],
    pr: ["0px", "5px", "10px"],
    height: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_reactChartjs.Pie, {
    data: dataset,
    options: options,
    ref: chartRef
  })), /*#__PURE__*/_react["default"].createElement(_Legends["default"], {
    legends: legends,
    device: device,
    chartHeight: chartHeight,
    colorScale: data.datasets[0].backgroundColor
  }));
};

var _default = Graph;
exports["default"] = _default;